$(document).ready(function() {
  tinymce.init({
    selector: '.tinymce',
    language: 'ru',
    height: 500,
    menubar: false,
    convert_urls : false, 
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste'
    ],
    toolbar: ' code | undo redo | formatselect | ' +
       'bold italic backcolor | alignleft aligncenter ' +
       'alignright alignjustify | bullist numlist outdent indent | ' +
       ' removeformat'
  });

  $('.tox-statusbar__branding').hide();
});